/**
 * @param {Object} src snapshot to copy
 * @returns {Object}
 */
export default function makeRoot(src) {
  const out = {};
  out.created_at = src.created_at;
  out.name = src.name;
  out.objective = src.objective;

  // SWALLOWED
  out.__type = 'ORGANISATION';
  out.__percentage = 100;
  out.__visibility = 'FULL';

  return out;
}
